<style lang="scss">
/* ===== Layout ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0 16px 16px;
    }
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-title-text {
    font-weight: 600;
    font-size: 14px;
}

/* ===== PC vs Mobile Toggle ===== */
.withdrawal-card-list {
    display: none;
    gap: 12px;

    .withdrawal-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .withdrawal-mobile-card.row-pending {
        background: #fffbe6;
    }

    .withdrawal-mobile-card.row-success {
        background: #f6ffed;
    }

    .withdrawal-mobile-card.row-failed {
        background: #fff1f0;
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 10px;
    }

    .mobile-field {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 72px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mobile-card-foot {
        display: flex;
        gap: 8px;
        padding-top: 8px;
        border-top: 1px solid #f5f5f5;
    }
}

/* ===== Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
}

/* ===== Row Status ===== */
:deep(.row-pending)>td {
    background: #fffbe6 !important;
}

:deep(.row-success)>td {
    background: #f6ffed !important;
}

:deep(.row-failed)>td {
    background: #fff1f0 !important;
}

/* ===== Status Text ===== */
.liu-text-success {
    color: #52c41a;
    font-weight: 500;
}

.liu-text-danger {
    color: #ff4d4f;
    font-weight: 500;
}

.liu-text-warning {
    color: #faad14;
    font-weight: 500;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {

    .withdrawal-table-pc,
    .table-pagination {
        display: none !important;
    }

    .withdrawal-card-list {
        display: flex !important;
        flex-direction: column;
    }

    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-card :deep(.ant-card-body) {
        padding: 0 12px 12px;
    }
}

@media screen and (max-width: 480px) {
    .mobile-label {
        min-width: 60px;
        font-size: 11px;
    }

    .mobile-value {
        font-size: 12px;
    }
}
</style>

<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">提现中心</span>
                                <a-tag color="blue">{{ Withdrawal_Conf.total }} 条</a-tag>
                            </div>
                        </template>

                        <a-table class="withdrawal-table-pc" :data-source="Withdrawal_data" :pagination="false"
                            row-key="id" :scroll="{ x: 1100 }" size="small" bordered :loading="tableLoading"
                            :columns="tableColumns" :row-class-name="getRowClass">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'money'">
                                    <div
                                        :class="{ 'liu-text-success': record.state == 1, 'liu-text-danger': record.state == -1 }">
                                        {{ record.money }}元
                                    </div>
                                </template>
                                <template v-else-if="column.key === 'skm'">
                                    <a-image :src="record.skm" width="80" height="80" fit="cover" />
                                </template>
                                <template v-else-if="column.key === 'act'">
                                    <div v-if="record.act == 'wx'">微信</div>
                                    <div v-else-if="record.act == 'zfb'">支付宝</div>
                                    <div v-else>未知</div>
                                </template>
                                <template v-else-if="column.key === 'state'">
                                    <div :class="{
                                        'liu-text-warning': record.state == 0,
                                        'liu-text-success': record.state == 1,
                                        'liu-text-danger': record.state == -1
                                    }">
                                        {{ getWithdrawalAct(record.state) }}
                                    </div>
                                </template>
                                <template v-else-if="column.key === 'res_code'">
                                    <div v-if="!isNull(record.res_code)">{{ record.res_code }}</div>
                                    <div v-else class="text-gray">-</div>
                                </template>
                                <template v-else-if="column.key === 'end_time'">
                                    <div v-if="!isNull(record.end_time)">{{ record.end_time }}</div>
                                    <div v-else>-</div>
                                </template>
                                <template v-else-if="column.key === 'action'">
                                    <div v-if="record.state == 0">
                                        <a-space direction="vertical" size="small">
                                            <a-button type="primary" size="small" style="width: 80px;"
                                                @click="updateWithdrawalFun1(1, record.id)">已打款</a-button>
                                            <a-button danger size="small" style="width: 80px;"
                                                @click="updateWithdrawalFun1(-1, record.id)">驳回</a-button>
                                        </a-space>
                                    </div>
                                    <div v-else-if="record.state == 1" class="liu-text-success">已完结</div>
                                    <div v-else-if="record.state == -1" class="liu-text-danger">已驳回</div>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="withdrawal-card-list" v-if="Withdrawal_data && Withdrawal_data.length > 0">
                            <a-card v-for="record in Withdrawal_data" :key="record.id" class="withdrawal-mobile-card"
                                :bordered="false" :class="getRowClass(record)">
                                <div class="mobile-card-head">
                                    <div class="mobile-card-title">
                                        提现 #{{ record.id }} / UID {{ record.uid }}
                                    </div>
                                    <a-tag :color="getStateTagColor(record.state)">{{ getWithdrawalAct(record.state)
                                        }}</a-tag>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">金额</span>
                                        <span class="mobile-value" :class="{
                                            'liu-text-success': record.state == 1,
                                            'liu-text-danger': record.state == -1,
                                            'liu-text-warning': record.state == 0
                                        }">{{ record.money }}元</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">方式</span>
                                        <span class="mobile-value">
                                            {{ record.act == 'wx' ? '微信' : record.act == 'zfb' ? '支付宝' : '未知' }}
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">收款码</span>
                                        <a-image :src="record.skm" width="60" height="60" fit="cover" />
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">备注</span>
                                        <span class="mobile-value">{{ record.remarks || '-' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">申请时间</span>
                                        <span class="mobile-value">{{ record.add_time }}</span>
                                    </div>
                                    <div class="mobile-field" v-if="record.end_time">
                                        <span class="mobile-label">处理时间</span>
                                        <span class="mobile-value">{{ record.end_time }}</span>
                                    </div>
                                    <div class="mobile-field" v-if="record.res_code">
                                        <span class="mobile-label">结果</span>
                                        <span class="mobile-value">{{ record.res_code }}</span>
                                    </div>
                                </div>
                                <div class="mobile-card-foot" v-if="record.state == 0">
                                    <a-button type="primary" size="small"
                                        @click="updateWithdrawalFun1(1, record.id)">已打款</a-button>
                                    <a-button danger size="small"
                                        @click="updateWithdrawalFun1(-1, record.id)">驳回</a-button>
                                </div>
                            </a-card>
                        </div>

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="Withdrawal_Conf.currentPage"
                                v-model:page-size="Withdrawal_Conf.pageSize" :page-size-options="[10, 25, 50]"
                                show-size-changer show-quick-jumper :show-total="(total) => `共 ${total} 条`"
                                :total="Withdrawal_Conf.total" @change="WithdrawalCurrentChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 处理对话框 -->
    <a-modal :mask-closable="false" v-model:open="withdrawalDialog.Visible" title="" :width="500" centered>
        <a-form style="padding: 16px 0;" :model="withdrawalDialog.form" layout="vertical">
            <a-form-item label="处理结果">
                <a-input type="textarea" :rows="5" v-model:value="withdrawalDialog.form.res_code" autocomplete="off" />
            </a-form-item>
        </a-form>
        <template #footer>
            <a-button @click="withdrawalDialog.Visible = false">取消</a-button>
            <a-button type="primary" @click="updateWithdrawal()">确定</a-button>
        </template>
    </a-modal>
</template>

<script>
import { defineComponent, ref, h } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull } from "@/utils/publicMethods"
import { message } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop,
    },
    data() {
        return {
            tableLoading: false,
            Withdrawal_Conf: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            Withdrawal_data: [],
            withdrawalDialog: {
                Visible: false,
                form: {
                    res_code: "",
                    id: "",
                    state: "",
                }
            }
        }
    },
    computed: {
        tableColumns() {
            return [
                { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' },
                { title: '用户UID', dataIndex: 'uid', key: 'uid', width: 100 },
                { title: '提现金额', key: 'money', width: 100 },
                { title: '收款码', key: 'skm', width: 100 },
                { title: '提现方式', key: 'act', width: 90 },
                { title: '备注', dataIndex: 'remarks', key: 'remarks', width: 120 },
                { title: '状态', key: 'state', width: 100 },
                { title: '处理结果', key: 'res_code', width: 150 },
                { title: '申请时间', dataIndex: 'add_time', key: 'add_time', width: 170 },
                { title: '处理时间', key: 'end_time', width: 170 },
                { title: '操作', key: 'action', width: 110, fixed: 'right' },
            ];
        }
    },
    methods: {
        getRowClass(record) {
            if (record.state == 1) return 'row-success';
            if (record.state == -1) return 'row-failed';
            return 'row-pending';
        },
        getStateTagColor(state) {
            if (state == 1) return 'green';
            if (state == -1) return 'red';
            return 'gold';
        },
        getWithdrawalAct(act) {
            switch (act) {
                case -1: return "提现驳回";
                case 0: return "等待审核";
                case 1: return "已打款";
                default: return "未知";
            }
        },
        isNull(text) {
            return isNull(text);
        },
        getUserWithdrawal() {
            openLoading()
            this.tableLoading = true
            const data = new FormData();
            data.append("page", this.Withdrawal_Conf.currentPage)
            data.append("pageSize", this.Withdrawal_Conf.pageSize)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/getUserWithdrawal', data, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 0) {
                        this.Withdrawal_data = res.data.data
                        this.Withdrawal_Conf.total = res.data.total ? res.data.total : 10
                    } else {
                        message.error(res.data.msg)
                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                    this.tableLoading = false
                })
        },
        WithdrawalSizeChange(val) {
            this.Withdrawal_Conf.pageSize = val
            this.getUserWithdrawal()
        },
        WithdrawalCurrentChange(val, pageSize) {
            this.Withdrawal_Conf.currentPage = val
            if (pageSize !== undefined) this.Withdrawal_Conf.pageSize = pageSize
            this.getUserWithdrawal()
        },
        updateWithdrawalFun1(state, id) {
            this.withdrawalDialog.form.state = state
            this.withdrawalDialog.form.id = id
            if (state == 1) {
                this.withdrawalDialog.form.res_code = "管理员已为您打款，请及时查收，若有问题请及时联系管理员"
                this.withdrawalDialog.Visible = true
            } else if (state == -1) {
                this.withdrawalDialog.form.res_code = "由于此订单存在异常，管理员已拒绝打款，请及时联系管理员进行处理"
                this.withdrawalDialog.Visible = true
            }
        },
        updateWithdrawal() {
            let act = this.withdrawalDialog.form.state
            let id = this.withdrawalDialog.form.id
            let value = this.withdrawalDialog.form.res_code
            openLoading()
            const data = new FormData();
            data.append("state", act)
            data.append("id", id)
            data.append("res_code", value)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/setWithdrawalStatus', data, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 0) {
                        message.success(res.data.msg)
                        this.getUserWithdrawal()
                    } else {
                        message.error(res.data.msg)
                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                    this.withdrawalDialog.Visible = false
                })
        }
    },
    mounted() {
        this.getUserWithdrawal()
    }
})
</script>
